import { GraphType, NodeType } from '@/utils/const'

function createPortal (dataBus) {
    if (dataBus.graphType === GraphType.FLOW_FROM_NODE) {
        return createPortalFrom(dataBus)
    }
    if (dataBus.graphType === GraphType.FLOW_TO_NODE) {
        return createPortalTo(dataBus)
    }
    let nodeList = dataBus.data.nodeList
    let nodeOpenMap = dataBus.nodeOpenMap
    let nodeOutList = []
    let nodeOutMap = {}
    let mapIdToNodeOut = {}

    const filterScenario = (parentOut, node, i) => {
        let nodeOut = {
            id: parentOut ? `${parentOut.id}-${i}` : node.id,
            type: node.type,
            name: node.name,
            isPortal: false,
            data: node,
            children: [],
            parent: parentOut,
            depth: -1,
            x: -1,
            y: -1,
            loopCheck: false,
            open: true
        }
        nodeOutList.push(nodeOut)
        nodeOutMap[nodeOut.id] = nodeOut
        if (mapIdToNodeOut[node.id]) {
            nodeOut.isPortal = true
        } else {
            if (parentOut) {
                if (node.parent.id === parentOut.data.id) {
                    mapIdToNodeOut[node.id] = nodeOut
                } else {
                    nodeOut.isPortal = true
                }
            } else {
                mapIdToNodeOut[node.id] = nodeOut
            }
        }
        if (typeof nodeOpenMap[nodeOut.id] !== 'boolean') {
            nodeOpenMap[nodeOut.id] = !nodeOut.isPortal
        }
        if (nodeOpenMap[nodeOut.id]) {
            for (let i = 0; i < node.children.length; i++) {
                nodeOut.children.push(filterScenario(nodeOut, node.children[i], i))
            }
        }
        return nodeOut
    }
    // start traveling from root
    for (let node of nodeList) {
        if (node.data.scenario_code === dataBus.activeScenarioCode) {
            if (node.isRoot || node.parent === null) {
                filterScenario(null, node, 0)
            }
        }
    }
    // traveling any loop left
    for (let node of nodeList) {
        if (node.data.scenario_code === dataBus.activeScenarioCode) {
            if (!mapIdToNodeOut[node.id]) {
                filterScenario(null, node, 0)
            }
        }
    }
    let linkOutList = []
    if (dataBus.graphType === GraphType.FLOW_STANDARD) {
        for (let nodeOut of nodeOutList) {
            for (let childOut of nodeOut.children) {
                linkOutList.push({
                    id: nodeOut.id + '-' + childOut.id,
                    source: nodeOut,
                    target: childOut
                })
            }
        }
    } else if (dataBus.graphType === GraphType.FLOW_CONTAIN_NODE) {
        nodeOutList.forEach(nodeOut => {
            nodeOut.children = []
        })
        let targetNodeOutList = nodeOutList.filter(nodeOut => nodeOut.data.id === dataBus.graphTypeData)
        nodeOutList = []
        targetNodeOutList.forEach(nodeOut => {
            nodeOutList.push(nodeOut)
            let node = nodeOut
            let parent = node.parent
            while (parent) {
                parent.children.push(node)
                linkOutList.push({
                    id: parent.id + '-' + node.id,
                    source: parent,
                    target: node
                })
                if (nodeOutList.includes(parent)) {
                    break
                } else {
                    nodeOutList.push(parent)
                    node = parent
                    parent = node.parent
                }
            }
        })
    }

    return {
        nodeList: nodeOutList,
        nodeMap: nodeOutMap,
        linkList: linkOutList
    }
}

function createPortalFrom (dataBus) {
    let nodeList = dataBus.data.nodeList
    let nodeOutMap = {}
    let rootOut = null
    for (let node of nodeList) {
        let nodeOut = {
            id: node.id,
            type: node.type,
            name: node.name,
            isPortal: false,
            data: node,
            children: [],
            parent: null,
            depth: -1,
            x: -1,
            y: -1,
            loopCheck: false,
            open: true
        }
        nodeOutMap[nodeOut.id] = nodeOut
        if (nodeOut.data.id === dataBus.graphTypeData) {
            rootOut = nodeOut
        }
    }
    let linkOutList = []
    let filterNodeOutList = []

    function loopTree (nodeOut) {
        filterNodeOutList.push(nodeOut)
        if (nodeOut.isPortal) {
            return
        }
        for (let i = 0; i < nodeOut.data.children.length; i++) {
            let child = nodeOut.data.children[i]
            let childOut = nodeOutMap[child.id]
            let nodeChildOut = null
            if (childOut.parent || childOut === rootOut) {
                nodeChildOut = {
                    id: 'portal-' + childOut.id + '-' + nodeOut.id + '-' + i,
                    type: 'STEP',
                    isPortal: true,
                    name: childOut.name,
                    data: childOut.data,
                    children: [],
                    parent: nodeOut,
                    depth: -1,
                    x: -1,
                    y: -1,
                    open: true
                }
            } else {
                nodeChildOut = childOut
            }
            nodeOut.children.push(nodeChildOut)
            nodeChildOut.parent = nodeOut
            linkOutList.push({
                id: nodeOut.id + '-' + nodeChildOut.id,
                source: nodeOut,
                target: nodeChildOut
            })
        }
        for (let childOut of nodeOut.children) {
            loopTree(childOut)
        }
    }

    loopTree(rootOut)

    return {
        nodeList: filterNodeOutList,
        nodeMap: nodeOutMap,
        linkList: linkOutList
    }
}

function createPortalTo (dataBus) {
    let nodeOutList = []
    let linkOutList = []
    let nodeOutMap = {}

    let targetNode = dataBus.data.mapCodeToNode[dataBus.graphTypeData]
    let targetOut = {
        id: targetNode.id,
        type: targetNode.type,
        name: targetNode.name,
        isPortal: false,
        data: targetNode,
        children: [],
        parent: null,
        depth: -1,
        x: -1,
        y: -1,
        open: true
    }
    nodeOutList.push(targetOut)
    nodeOutMap[targetOut.id] = targetOut

    for (let node of dataBus.data.nodeList) {
        if (node.type === NodeType.STEP) {
            for (let childCard of node.children) {
                for (let childStep of childCard.children) {
                    if (childStep === targetNode) {
                        let stepOut = {
                            id: node.id,
                            type: node.type,
                            name: node.name,
                            isPortal: false,
                            data: node,
                            children: [],
                            parent: null,
                            depth: -1,
                            x: -1,
                            y: -1,
                            open: true
                        }
                        nodeOutList.push(stepOut)
                        nodeOutMap[stepOut.id] = stepOut
                        let cardOut = {
                            id: childCard.id,
                            type: childCard.type,
                            name: childCard.name,
                            isPortal: false,
                            data: childCard,
                            children: [targetOut],
                            parent: stepOut,
                            depth: -1,
                            x: -1,
                            y: -1,
                            open: true
                        }
                        stepOut.children.push(cardOut)
                        nodeOutList.push(cardOut)
                        nodeOutMap[cardOut.id] = cardOut

                        linkOutList.push({
                            id: stepOut.id + '-' + cardOut.id,
                            source: stepOut,
                            target: cardOut
                        })
                        linkOutList.push({
                            id: cardOut.id + '-' + targetOut.id,
                            source: cardOut,
                            target: targetOut
                        })
                    }
                }
            }
        }
    }

    return {
        nodeList: nodeOutList,
        nodeMap: nodeOutMap,
        linkList: linkOutList
    }
}

export default createPortal
